module.exports = __webpack_public_path__ + "img/316.d52f4ca8.png";